import { CommonRequestOptions, makeRequest } from './makeRequest';

export type NotificationIcon =
   | 'check'
   | 'question-circle'
   | 'times'
   | 'pencil'
   | 'exclamation'
   | 'briefcase'
   | 'user-plus'
   | 'user-times'
   | 'certificate'
   | 'circle'
   | 'thumbs-o-up'
   | 'thumbs-o-down'
   | 'clock-o'
   | 'pencil-square-o'
   | 'exclamation-circle';

export type Notification = {
   notificationid: string;
   url: string;
   message: string;
   icon: NotificationIcon;
   timeSince: string;
};

export type GetRecentNotificationsResult = {
   notifications: Notification[];
   hasMore: boolean;
   total: number;
};

export type GetRecentNotificationsRequestOptions = CommonRequestOptions & {
   page?: number;
};

export async function getRecentNotifications({
   page = 1,
   ...common
}: GetRecentNotificationsRequestOptions = {}): Promise<GetRecentNotificationsResult> {
   return makeRequest('get', 'notifications/recent', {
      ...common,
      query: {
         page,
      },
   });
}

export type GetRecentNotificationsForUserRequestOptions = CommonRequestOptions & {
   userid: number;
   page?: number;
};

export async function getRecentNotificationsForUser(
   { userid, page = 1, ...common }: GetRecentNotificationsForUserRequestOptions = { userid: 0 }
): Promise<GetRecentNotificationsResult> {
   return makeRequest('get', 'notifications/recent/' + userid, {
      ...common,
      query: {
         page,
      },
   });
}

export type MarkNotificationAsReadResult = { marked: string[] };

export function markNotificationAsRead(
   notificationid: string,
   common: CommonRequestOptions = {}
): Promise<MarkNotificationAsReadResult> {
   return makeRequest('get', `notifications?ids=${notificationid}`, {
      ...common,
   });
}

export function markAllNotificationsAsRead(common: CommonRequestOptions = {}): Promise<null> {
   return makeRequest('delete', `notifications/all`, {
      ...common,
   });
}

export type GetGlobalNotificationsResult = {
   notifications: {
      notificationid: number;
      userid: number | null;
      message: string;
      expires: number;
      permanent: number;
      posted: number;
   }[];
};

export async function getGlobalNotifications(
   common: CommonRequestOptions = {}
): Promise<GetGlobalNotificationsResult> {
   return makeRequest('get', 'notifications/global', { ...common });
}

export async function dismissGlobalUserNotification(
   notificationid: number,
   common: CommonRequestOptions = {}
): Promise<void> {
   await makeRequest('delete', `notifications/global/${notificationid}`, { ...common });
}
